"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinneFormatter = void 0;
const FuehrungsrinneFormValidator_1 = require("./FuehrungsrinneFormValidator");
class FuehrungsrinneFormatter {
    static gewicht(options) {
        return FuehrungsrinneFormValidator_1.FuehrungsrinneFormValidator.gewicht(options);
    }
    static laenge(options) {
        return FuehrungsrinneFormValidator_1.FuehrungsrinneFormValidator.laenge(options);
    }
}
exports.FuehrungsrinneFormatter = FuehrungsrinneFormatter;
//# sourceMappingURL=FuehrungsrinneFormatter.js.map